import React, { useState, memo } from 'react';
import { DawidConfirm } from './confirm.jsx';
import defaultLogo from '../../static/images/dawid_logo.svg';

function DawidHeader({ width, logo = defaultLogo, resetSession }) {
  const [resetOpen, setResetOpen] = useState(false);
  return (
    <div className="max-w-5xl mx-auto my-8 px-4">
      <img
        id="logo"
        src={logo}
        alt="Document assembly wizard"
        title="Click here to restart from the beginning"
        className="max-w-[280px] cursor-pointer hover:opacity-80 transition-opacity"
        onClick={() => setResetOpen(true)}
      />
      <DawidConfirm
        open={resetOpen}
        onConfirm={() => { resetSession(); setResetOpen(false); }}
        onCancel={() => setResetOpen(false)}
      />
    </div>
  );
}

export default memo(DawidHeader, (prev, next) => (
  prev.logo === next.logo && prev.width === next.width
));
